(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/authorization/assets/javascript/init.js') >= 0) return;  svs.modules.push('/modules/authorization/assets/javascript/init.js');

'use strict';

const {
  POST_MESSAGE_TYPES,
  buildOnboardingUrl,
  isInIamIframe,
  postMessageToParent,
  showDialog,
  parentTrackEvent,
  checkPeP,
  saveUserId
} = svs.authorization.utils;
const {
  makeInternal
} = svs.utils.url;
const Logger = svs.authorization.logger;
const loginTrackEvent = {
  category: 'Users',
  opt_label: 'Janssen'
};
const parseLastLoginTime = (inDate, withSeconds) => "".concat(inDate.substring(0, 10), " ").concat(withSeconds ? inDate.substring(11, 19) : inDate.substring(11, 16));
svs.authorization.init = async () => {
  var _svs$authorization$da, _svs$authorization$da2, _svs$authorization$da7;
  const inverted = svs.authorization.data.sessionData.isPnp ? false : 'inverted';
  const loader = new svs.ui.Loader('.js-authorization-view-loader', {
    delayedShow: false
  }).show(300, inverted);
  const loginType = ((_svs$authorization$da = svs.authorization.data.sessionData) === null || _svs$authorization$da === void 0 ? void 0 : _svs$authorization$da.loginType) || '';
  if (typeof loginType === 'string' && loginType.length > 0) {
    loginTrackEvent.opt_label = "Janssen-".concat(loginType);
  }
  if ((_svs$authorization$da2 = svs.authorization.data.error) !== null && _svs$authorization$da2 !== void 0 && _svs$authorization$da2.isError) {
    var _svs$authorization$da3, _svs$authorization$da4, _svs$authorization$da5, _svs$authorization$da6;
    const title = ((_svs$authorization$da3 = svs.authorization.data.error) === null || _svs$authorization$da3 === void 0 ? void 0 : _svs$authorization$da3.title) || 'Misslyckad inloggning';
    const message = ((_svs$authorization$da4 = svs.authorization.data.error) === null || _svs$authorization$da4 === void 0 ? void 0 : _svs$authorization$da4.message) || 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
    const errorRedirectUrl = (_svs$authorization$da5 = svs.authorization.data.error) === null || _svs$authorization$da5 === void 0 ? void 0 : _svs$authorization$da5.errorRedirectUrl;
    const redirectUriOnError = errorRedirectUrl || "".concat(svs.core.urlMapping.get('loginIAM'), "?returnUrl=").concat((_svs$authorization$da6 = svs.authorization.data.error) === null || _svs$authorization$da6 === void 0 ? void 0 : _svs$authorization$da6.returnUrl);

    loginTrackEvent.action = 'Login Failure';
    await parentTrackEvent(loginTrackEvent);
    if (isInIamIframe) {
      postMessageToParent({
        value: {
          title,
          message,
          redirectUrl: redirectUriOnError
        },
        type: POST_MESSAGE_TYPES.SHOW_DIALOG
      });
    } else {
      loader.hide();
      await showDialog(title, message);
      loader.show();
      window.location.href = redirectUriOnError;
    }
  } else if ((_svs$authorization$da7 = svs.authorization.data.success) !== null && _svs$authorization$da7 !== void 0 && _svs$authorization$da7.isSuccess) {
    var _svs$authorization$da8, _svs$authorization$da9;
    const returnUrl = svs.authorization.data.success.redirectUri || svs.core.urlMapping.get('startPage');
    const redirectUri = "".concat(svs.core.urlMapping.get('legalInfo'), "?returnUrl=").concat(encodeURIComponent(makeInternal(returnUrl)));
    const lastLoginTime = ((_svs$authorization$da8 = svs.authorization.data.sessionData) === null || _svs$authorization$da8 === void 0 ? void 0 : _svs$authorization$da8.lastLoginTime) || '';
    const isNewCustomer = ((_svs$authorization$da9 = svs.authorization.data.sessionData) === null || _svs$authorization$da9 === void 0 ? void 0 : _svs$authorization$da9.isNewCustomer) || false;
    const navigateCallback = url => {
      if (isInIamIframe) {
        postMessageToParent({
          value: url,
          type: POST_MESSAGE_TYPES.PARENT_REDIRECT
        });
      } else {
        window.location.href = url;
      }
    };
    const navigateCallbackPost = (url, options) => {
      if (isInIamIframe) {
        postMessageToParent({
          value: url,
          type: POST_MESSAGE_TYPES.PARENT_REDIRECT_POST,
          options
        });
      } else {
        svs.utils.form.postToUrl(url, options);
      }
    };
    const setLastLoginTime = () => new Promise(resolve => {
      svs.core.userSession.set('lastLoginTime', parseLastLoginTime(lastLoginTime, false), error => {
        if (error) {
          Logger.warn("failed to set lastLoginTime to userSession, data was: ".concat(parseLastLoginTime(lastLoginTime, false), ", error was: ").concat(error));
        } else {
          Logger.info("set lastLoginTime in userSession to: ".concat(parseLastLoginTime(lastLoginTime, false)));
        }
        resolve();
      });
    });
    const setIamLoginType = () => new Promise(resolve => {
      svs.core.userSession.set('iamLoginType', loginType, error => {
        if (error) {
          Logger.warn("failed to set iamLoginType to userSession, data was: ".concat(loginType, ", error was: ").concat(error));
        } else {
          Logger.info("set iamLoginType in userSession to: ".concat(loginType));
        }
        resolve();
      });
    });
    const updateIsNewCustomer = () => new Promise(resolve => {
      svs.core.deviceSession.set('isNewCustomer', 'iam', false, error => {
        if (error) {
          Logger.warn("failed to set isNewCustomer to deviceSession, data was: false, error was: ".concat(error));
        } else {
          Logger.info('set isNewCustomer in deviceSession to: false');
        }
        resolve();
      });
    });
    const updateFirstSession = () => new Promise(resolve => {
      svs.core.userSession.set('customerFirstSession', true, error => {
        if (error) {
          Logger.warn("failed to set customerFirstSession to userSession, data was: true, error was: ".concat(error));
        } else {
          Logger.info('set customerFirstSession in userSession to: true');
        }
        resolve();
      });
    });
    await setIamLoginType();
    await saveUserId();
    lastLoginTime && lastLoginTime !== '' && (await setLastLoginTime());

    loginTrackEvent.action = 'Login Success';
    await parentTrackEvent(loginTrackEvent);
    if (isNewCustomer) {
      await updateIsNewCustomer();
      await updateFirstSession();
      const kycStatus = await checkPeP();
      const onboardingdata = buildOnboardingUrl();
      const urlWithReturn = "".concat(onboardingdata.url, "?returnUrl=").concat(encodeURIComponent(onboardingdata.returnUrl));
      if (kycStatus === 4) {
        navigateCallbackPost("".concat(svs.core.urlMapping.get('legalInfo'), "/penningtvatt"), {
          returnUrl: urlWithReturn
        });
        return;
      }
      if (onboardingdata.shouldPost) {
        navigateCallbackPost(onboardingdata.url, {
          returnUrl: onboardingdata.returnUrl
        });
      } else {
        navigateCallback(urlWithReturn);
      }
      return;
    }
    navigateCallback(redirectUri);
  }
};
svs.authorization.init();

 })(window);